import { render, staticRenderFns } from "./GameCardTemplate.vue?vue&type=template&id=38369fd2&scoped=true&"
import script from "./GameCardTemplate.vue?vue&type=script&lang=js&"
export * from "./GameCardTemplate.vue?vue&type=script&lang=js&"
import style0 from "./GameCardTemplate.vue?vue&type=style&index=0&id=38369fd2&scoped=true&lang=css&"
import style1 from "./GameCardTemplate.vue?vue&type=style&index=1&id=38369fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38369fd2",
  null
  
)

export default component.exports